

import {
  Button,
  Divider,
  Grid,
  Modal,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "axios";
import admission from "../../../../assets/popup.png";
import { useLocation, useNavigate } from "react-router-dom";

const Popup = ({ open, onClose, isApplyButton }) => {
  const sessionValue = typeof window !== 'undefined' ? sessionStorage.getItem('lead_flag') : null;
  const leadFlag = sessionValue ? sessionValue : 'Unknown';
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const source = params.get('source');

    if (source) {
      console.log(' source is present:', source); // e.g., "whatsapp"
    } else {
      console.log(' source is not present');
    }
  }, [location.search]);

  const mobileScreen = useMediaQuery(
    "(min-width: 360px) and (max-width: 599px)"
  );
  const laptopScreen = useMediaQuery(
    "(min-width: 1200px) and (max-width: 1440px)"
  );

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [nameError, setNameError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const validateName = (value) => {
    if (!/^[A-Za-z\s]+$/.test(value) || value.length < 3) {
      setNameError("Enter a valid name");
      return false;
    }
    setNameError("");
    return true;
  };

  const validatePhone = (value) => {
    if (!/^\d{10}$/.test(value)) {
      setPhoneError("Enter a valid 10-digit phone number");
      return false;
    }
    setPhoneError("");
    return true;
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
    validateName(value);
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setPhone(value);
    validatePhone(value);
  };

  const handleSubmit = async () => {
    if (!validateName(name) || !validatePhone(phone)) return;

    const requestData = {
      name,
      phone,
      leadType: "PodarPrepYelahanka",
      leadFlag,
    };

    try {
      const response = await axios.post(
        "https://gmc.getmycollege.com/university/addExternalSourceLead",
        requestData,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response?.status >= 200 && response?.status < 300) {
        setName("");
        setPhone("");
        localStorage.setItem("isFormSubmited", true);
        onClose();
        navigate('/thank-you');
      } else {
        alert("Failed to add lead");
      }
    } catch (error) {
      alert("Something went wrong. Please try again later.");
      console.error(error);
    }
  };

  return (
    <Modal open={open} onClose={isApplyButton && onClose}>
      <Grid
        container
        xs={12}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "#ffffff",
          borderRadius: 1,
          width: { xs: "350px", md: "400px" },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          px: laptopScreen ? 2 : 4,
          py: mobileScreen ? 2 : laptopScreen ? 4 : 0,
        }}
      >
        {/* <Grid
            item
            md={6}
            xs={12}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: mobileScreen ? "center" : "center",
            }}
          >
            <Grid
              sx={{
                width: mobileScreen ? 330 : laptopScreen ? 870 : 800,
                height: mobileScreen ? 240 : laptopScreen ? 450 : 560,
              }}
            >
              <img
                src={admission}
                alt="admissionbanner"
                style={{ width: "300px", height: "300px", objectFit: "fill" }}
              />
            </Grid>
          </Grid> */}

        <img
          src={admission}
          alt="admissionbanner"
          style={{ width: "120px", height: "120px", objectFit: "fill" }}
        />
        <Typography
          variant="h3"
          sx={{
            fontSize: mobileScreen ? 20 : laptopScreen ? 25 : 28,
            fontWeight: 600,
          }}
        >
          Admission Enquiry
        </Typography>

        <Divider sx={{ background: "#2E65AD", width: 150, my: 2 }} />

        <Typography
          sx={{
            fontSize: laptopScreen ? 15 : 17,
            textAlign: "center",
            px: mobileScreen ? 3 : 0,
          }}
        >
          Join the Podar Prep Family - Where Learning Feels Like Fun!
        </Typography>

        {/* <Divider sx={{ background: "#2E65AD", width: 150, my: 2 }} /> */}

        <Grid
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            py: mobileScreen ? 2 : laptopScreen ? 3 : 4,
          }}
        >
          <Grid container spacing={mobileScreen ? 1.5 : 3}>
            <Grid item md={12} xs={12}>
              <TextField
                fullWidth
                placeholder="Enter Your Name"
                value={name}
                onChange={handleNameChange}
                error={!!nameError}
                helperText={nameError}
                inputProps={{
                  style: {
                    fontSize: mobileScreen ? 12 : laptopScreen ? 10 : 13,
                    background: "#ffff",
                  },
                }}
                variant="outlined"
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                fullWidth
                placeholder="Enter Your Ph.No"
                value={phone}
                onChange={handlePhoneChange}
                error={!!phoneError}
                helperText={phoneError}
                inputProps={{
                  maxLength: 10,
                  style: {
                    fontSize: mobileScreen ? 12 : laptopScreen ? 10 : 13,
                    background: "#fff",
                  },
                }}
              // variant="outlined"
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleSubmit}
                sx={{
                  height: mobileScreen ? 30 : laptopScreen ? 40 : 40,
                  fontWeight: 600,
                  borderRadius: 0,
                  background: "#1d67ab",
                  "&:hover": { background: "#fdce0d" },
                  fontSize: mobileScreen ? 14 : laptopScreen ? 14 : 15,
                }}
              >
                Apply Now
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default Popup;

